import 'bootstrap/dist/css/bootstrap.min.css';
import GlobalStyle from './GlobalStyle/style'
import Routes from "./Routes";
import { GameProvider } from './providers/GameContext';
import { RankingIndustryProvider } from './providers/RankingIndustryContext';
import { RankingMarketProvider } from './providers/RankingMarketContext';

function App() {
  return (
    <div>
      <GlobalStyle />
      <GameProvider>
        <RankingIndustryProvider>
          <RankingMarketProvider>
            <Routes />
          </RankingMarketProvider>
        </RankingIndustryProvider>
      </GameProvider>

    </div>
  );
}

export default App;
